import React from "react";
import styled from "styled-components";

export default styled.div`
    font-size: 13px;
    color: #909090;
    float: left;
    width: 50%;
    text-align: left;

    &:nth-child(2) {
        text-align: right;
    }
`;